import type { PainPoint } from '../types/content'

export const painPoints: PainPoint[] = [
  {
    problem:
      'Lost evenings searching for progressions that actually work, flow logically, and match your specific player’s level',
    impact: 'Your energy is gone before the lesson even starts',
  },
  {
    problem:
      'Sessions that feel repetitive — because you keep going back to the same drills and concepts you already know',
    impact: 'Players stop feeling progress and quietly disengage',
  },
  {
    problem: 'Visible improvisation that quietly erodes your confidence as a coach',
    impact: 'You second-guess yourself in front of your players',
  },
  {
    problem: 'Not enough variety between weeks — and players who slowly lose motivation',
    impact: 'Retention drops without anyone knowing exactly why',
  },
  {
    problem: 'Weekends spent planning instead of resting, recharging, or simply living your life',
    impact: 'Burnout builds — and it shows on the court',
  },
]
